import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSmartTable,
} from '@coreui/react-pro'

import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import UserService from 'src/service/UserService'
const LoginMember = (props) => {
  const [loading, setLoading] = useState()

  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState(props.users)
  const navigate = useNavigate()
  useEffect(() => {
    setLoading(true)

    const offset = itemsPerPage * activePage - itemsPerPage

    let params = new URLSearchParams()

    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })

    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    UserService.loginUserList(offset, itemsPerPage, activePage, params)
      .then((result) => {
        setUsers(result.data)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [activePage, columnFilter, columnSorter, itemsPerPage])
  const columns = [
    {
      label: 'Member ID',
      key: 'id',
    },
    {
      label: 'Member Name',
      key: 'full_name',
    },
    {
      label: 'Email',
      key: 'email',
    },
    {
      label: 'Phone',
      key: 'phone',
    },
    {
      label: 'Login Time',
      key: 'login_at',
    },
    {
      label: 'Last Activity',
      key: 'last_activity_at',
    },
    {
      label: 'Device',
      key: 'device_type',
    },
    {
      label: 'Status',
      key: 'online_status',
      filter: false,
    },
    {
      label: 'History',
      key: 'history',
      filter: false,
      sorter: false,
    },
  ]

  // user history
  const [historyVisible, setHistoryVisible] = useState(false)
  const [historyData, setHistoryData] = useState([])
  const [historyLoading, setHistoryLoading] = useState(false)
  const openHistory = async (userId) => {
    setHistoryVisible(true)
    setHistoryLoading(true)

    try {
      const res = await UserService.memberLoginHistory(userId)

      if (res.success) {
        setHistoryData(res.data)
      }
    } finally {
      setHistoryLoading(false)
    }
  }
  return (
    <>
      <strong>Count: {users?.total || 0}</strong>
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          login_at: (item) => (
            <td>{item.login_at ? moment(item.login_at).format('DD.MM.YYYY HH:mm') : '-'}</td>
          ),

          last_activity_at: (item) => (
            <td>
              {item.last_activity_at
                ? moment(item.last_activity_at).format('DD.MM.YYYY HH:mm')
                : '-'}
            </td>
          ),

          device_type: (item) => <td>{item.device_type || '-'}</td>,

          online_status: () => (
            <td>
              <CBadge color="success">Online</CBadge>
            </td>
          ),

          history: (item) => (
            <td>
              <CButton size="sm" color="primary" onClick={() => openHistory(item.id)}>
                History
              </CButton>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <CModal visible={historyVisible} onClose={() => setHistoryVisible(false)} size="xl">
        <CModalHeader>
          <CModalTitle>Login History</CModalTitle>
        </CModalHeader>

        <CModalBody
          style={{
            maxHeight: '500px',
            overflowY: 'auto',
          }}
        >
          {historyLoading ? (
            <p>Loading...</p>
          ) : (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Device</th>
                  <th>IP Address</th>
                  <th>Login Time</th>
                  <th>Last Activity</th>
                  <th>Logout Time</th>
                </tr>
              </thead>

              <tbody>
                {historyData.length > 0 ? (
                  historyData.map((row) => (
                    <tr key={row.id}>
                      <td>{row.device_type}</td>

                      <td>{row.ip_address}</td>

                      <td>
                        {row.login_at ? moment(row.login_at).format('DD.MM.YYYY HH:mm:ss') : '-'}
                      </td>

                      <td>
                        {row.last_activity_at
                          ? moment(row.last_activity_at).format('DD.MM.YYYY HH:mm:ss')
                          : '-'}
                      </td>

                      <td>
                        {row.logout_at ? (
                          moment(row.logout_at).format('DD.MM.YYYY HH:mm:ss')
                        ) : (
                          <CBadge color="success">Active Session</CBadge>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No history found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </CModalBody>

        <CModalFooter>
          <CButton color="secondary" onClick={() => setHistoryVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default LoginMember
